import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  is_active: false,
  title: '',
  content: '',
  type: '',
  options: {},
  extraOptions: {},
  parent_modal: '',
}

export const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    setModal: (state, action) => {
      state.is_active = action.payload.is_active
      state.title = action.payload.title
      state.content = action.payload.content
      state.type = action.payload.type
      state.options = action.payload.options
      state.parent_modal = action.payload.parent_modal
      state.extraOptions = action.payload.extraOptions || {}
    }
  }
})

export const { setModal } = modalSlice.actions

export const selectModal = (state) => state.modal

export default modalSlice.reducer
